module.exports = __webpack_public_path__ + "static/docker-0576a290be2f6287676f0e4b842b8be3.png";